import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import asyncAction from 'modules/core/lib/asyncAction'

import qualificationEntries from 'modules/onboarding/store/collections/qualificationEntries'
import QualificationEntry from 'modules/onboarding/store/models/QualificationEntry'

const useContactSales = () => {
  const { email } = useCurrentSession()

  // TODO: Move upgrade request to graphql
  const handleClick = async (onSuccess: () => void) => {
    const { success } = await asyncAction(
      () => {
        return qualificationEntries.create({
          contact_email: email,
          target: QualificationEntry.TargetTeams.sales,
          marketing_form_campaign: QualificationEntry.Campaigns.contactSalesApp,
        })
      },
      {
        errorFlash: true,
        successFlash: false,
      }
    )

    if (success) {
      onSuccess()
    }
  }

  return { handleClick }
}

export default useContactSales
